module.exports = __webpack_public_path__ + "img/bg_graduacao.8f87dd1b.jpg";